import { z } from 'zod';
import { BaseResponseSchema, uuidSchema, } from './primitives.js';
export const EncryptionKeyStatusSchema = z.enum(['ACTIVE', 'DEPRECATED', 'REVOKED']);
export const EncryptionKeyTypeSchema = z.enum(['PROVIDER_MANAGED', 'BYOK']);
export const EncryptionKeySummarySchema = z.object({
    id: z.number(),
    keyId: uuidSchema,
    tenantId: uuidSchema.nullable(),
    keyType: EncryptionKeyTypeSchema,
    kmsKeyId: z.string(),
    status: EncryptionKeyStatusSchema,
    activatedAt: z.string().nullable(),
    deprecatedAt: z.string().nullable(),
    revokedAt: z.string().nullable(),
    revocationReason: z.string().nullable(),
    createdAt: z.string().nullable(),
    updatedAt: z.string().nullable(),
    kmsAutoRotation: z.boolean().optional(),
    tenant: z
        .object({
        id: z.string(),
        name: z.string(),
    })
        .nullable()
        .optional(),
});
export const EncryptionKeyDetailSchema = EncryptionKeySummarySchema.extend({
    isCustomerKey: z.boolean().optional(),
    customerKeyFingerprint: z.string().nullable().optional(),
    tenant: z
        .object({
        id: z.string(),
        name: z.string(),
        subdomain: z.string().optional(),
    })
        .nullable()
        .optional(),
});
export const ListEncryptionKeysRequestSchema = z.object({
    status: EncryptionKeyStatusSchema.optional(),
    tenantId: uuidSchema.optional(),
    limit: z.coerce.number().int().min(1).max(100).default(50),
    offset: z.coerce.number().int().min(0).default(0),
});
export const ListEncryptionKeysResponseSchema = BaseResponseSchema.extend({
    data: z.array(EncryptionKeySummarySchema),
    pagination: z.object({
        total: z.number(),
        limit: z.number(),
        offset: z.number(),
        hasMore: z.boolean(),
    }),
});
export const GetEncryptionKeyResponseSchema = BaseResponseSchema.extend({
    data: EncryptionKeyDetailSchema,
});
//# sourceMappingURL=encryption-keys.schemas.js.map